import { render, staticRenderFns } from "./ColorCrewContact.vue?vue&type=template&id=28223aae&scoped=true&lang=pug&"
import script from "./ColorCrewContact.vue?vue&type=script&lang=js&"
export * from "./ColorCrewContact.vue?vue&type=script&lang=js&"
import style0 from "./ColorCrewContact.vue?vue&type=style&index=0&id=28223aae&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28223aae",
  null
  
)

export default component.exports